import { useQuery } from "@tanstack/react-query";
import { core } from "../lib/api";

export interface WalletBlock { balance: number; usedPercent: number; type: "Promotional" | "Top-up"; remaining: number; consumed: number; started: boolean; }

export interface WalletState { promotional: WalletBlock; topup: WalletBlock; }

interface CreditBlock {
  limit: number;
  consumption: number;
  status?: "started" | "not_started";
}

interface CreditResponse {
  free_credit: CreditBlock;
  paid_credit: CreditBlock;
}

function toBlock(type: "Promotional" | "Top-up", block?: CreditBlock): WalletBlock {
  // Free credit is active by default; paid (top-up) credit is dormant until an admin explicitly starts it.
  const started = type === "Promotional" ? block?.status !== "not_started" : block?.status === "started";
  const limit = started ? (block?.limit || 0) : 0;
  const consumption = started ? (block?.consumption || 0) : 0;
  const remaining = limit - consumption;
  const usedPercent = limit > 0 ? Math.round((consumption / limit) * 100) : 0;
  return { balance: limit, usedPercent, type, remaining, consumed: consumption, started };
}

export function useWallet(): WalletState {
  const { data } = useQuery({
    queryKey: ["wallet-balance"],
    queryFn: () => core<CreditResponse>("/api/v1/credits/me"),
    staleTime: 60000,
  });

  return {
    promotional: toBlock("Promotional", data?.free_credit),
    topup: toBlock("Top-up", data?.paid_credit),
  };
}
